/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { z } from 'zod';

/* -------------------------------------------------------------------------- */
/*                                   Config                                   */
/* -------------------------------------------------------------------------- */

const schema = z.object({
  VITE_NODE_ENV: z.enum(['development', 'test', 'staging', 'production']),
  VITE_PHYSIOM_KINE_FRONT_BASE_URL: z.string(),
  VITE_PHYSIOM_KINE_API_BASE_URL: z.string(),
  VITE_VONAGE_APP_ID: z.string(),
  VITE_CLARITY_PROJECT_ID: z.string(),
  VITE_SENTRY_AUTH_TOKEN: z.string(),
  VITE_SENTRY_DSN: z.string(),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(
    `❌ Invalid environment variables: ${JSON.stringify(
      parsed.error.format(),
      null,
      4
    )}`
  );
}

export const env = {
  nodeEnv: parsed.data.VITE_NODE_ENV,
  physiomKine: {
    front: {
      baseUrl: parsed.data.VITE_PHYSIOM_KINE_FRONT_BASE_URL,
    },
    api: {
      baseUrl: parsed.data.VITE_PHYSIOM_KINE_API_BASE_URL,
    },
    vonage: {
      appId: parsed.data.VITE_VONAGE_APP_ID,
    },
    clarity: {
      projectId: parsed.data.VITE_CLARITY_PROJECT_ID,
    },
    sentry: {
      authToken: parsed.data.VITE_SENTRY_AUTH_TOKEN,
      dsn: parsed.data.VITE_SENTRY_DSN,
    },
  },
} as const;
